import { Stack, Typography, useTheme } from '@mui/material';

import { avatarTexts } from '../constants';

const AvatarHeader = () => {
    const theme = useTheme();
    return (
        <Stack
            direction='column'
            alignItems='center'
            gap={1.5}
            component='header'
            textAlign='center'
            zIndex={1}
        >
            <Typography variant='h2' color='white' fontSize='2.5rem' fontWeight={400}>
                {avatarTexts.header}
            </Typography>
            <Typography
                variant='h3'
                color={theme.palette.customColors.lightOrange}
                fontSize='1.5rem'
            >
                {avatarTexts.subheader}
            </Typography>
        </Stack>
    );
};

export default AvatarHeader;
